import { useContext } from "react";
import SliderContext from "./sliderContext";


const useSlider = () => {
    return useContext(SliderContext);
};

export default useSlider;